import React, { Component } from 'react';
import RequisitionModel from '../../../../models/RequisitionModel';
import formatString from '../../../../utilities/format-string';

class Table extends Component {
  state = {
    totalPayWeek: 0.0,
  };

  componentDidMount = () => {
    const totalPayWeek = this.props.amounts.reduce((total, amount) => {
      return (
        total + this.setPay(this.props.requisition, amount.monto_autorizado)
      );
    }, 0.0);
    this.setState({
      totalPayWeek,
    });
  };

  setPayWeekCustom = (requisition, monto_autorizado) => {
    let payWeek = RequisitionModel.setPayWeekCustom(
      requisition,
      monto_autorizado
    );

    return payWeek;
  };

  setPayWeek = (requisition, monto_autorizado) => {
    let payWeek = 0.0;
    payWeek = (monto_autorizado / 1000) * requisition.factor_cobro;

    payWeek = parseFloat(payWeek);

    let decimal = payWeek - Math.trunc(payWeek);
    if (decimal > 0 && decimal < 0.5) {
      payWeek = Math.trunc(payWeek) + 0.5;
    } else if (decimal > 0.5) {
      payWeek = Math.trunc(payWeek) + 1;
    }

    return payWeek;
  };

  setPay = (requisition, monto_autorizado) => {
    let pay = 0.0;
    console.log(requisition);

    if (requisition.prestamo_personalizado_cantidad_pagos) {
      pay = this.setPayWeekCustom(requisition, monto_autorizado);
    } else {
      pay = this.setPayWeek(requisition, monto_autorizado);
    }
    return pay;
  };

  render() {
    return (
      <table style={{ ...styles.table, ...this.props.style }}>
        <tbody>
          <tr>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              rowSpan="2"
              width="3%"
            ></td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              rowSpan="2"
              width="32%"
            >
              NOMBRE
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              rowSpan="2"
              className="text-center"
              width="10%"
            >
              {this.props.requisition.prestamo_personalizado_periodicidad &&
              this.props.requisition.prestamo_personalizado_periodicidad !== 7
                ? 'PAGO DEL PERIODO'
                : 'PAGO SEMANAL'}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
              width="11%"
            >
              {this.props.newNumWeekArray[0]
                ? (this.props.requisition.prestamo_personalizado_periodicidad &&
                  this.props.requisition.prestamo_personalizado_periodicidad !==
                    7
                    ? 'PAGO '
                    : 'SEMANA ') + this.props.newNumWeekArray[0]
                : ''}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
              width="11%"
            >
              {this.props.newNumWeekArray[1]
                ? (this.props.requisition.prestamo_personalizado_periodicidad &&
                  this.props.requisition.prestamo_personalizado_periodicidad !==
                    7
                    ? 'PAGO '
                    : 'SEMANA ') + this.props.newNumWeekArray[1]
                : ''}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
              width="11%"
            >
              {this.props.newNumWeekArray[2]
                ? (this.props.requisition.prestamo_personalizado_periodicidad &&
                  this.props.requisition.prestamo_personalizado_periodicidad !==
                    7
                    ? 'PAGO '
                    : 'SEMANA ') + this.props.newNumWeekArray[2]
                : ''}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
              width="11%"
            >
              {this.props.newNumWeekArray[3]
                ? (this.props.requisition.prestamo_personalizado_periodicidad &&
                  this.props.requisition.prestamo_personalizado_periodicidad !==
                    7
                    ? 'PAGO '
                    : 'SEMANA ') + this.props.newNumWeekArray[3]
                : ''}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
              width="11%"
            >
              {this.props.newNumWeekArray[4]
                ? (this.props.requisition.prestamo_personalizado_periodicidad &&
                  this.props.requisition.prestamo_personalizado_periodicidad !==
                    7
                    ? 'PAGO '
                    : 'SEMANA ') + this.props.newNumWeekArray[4]
                : ''}
            </td>
          </tr>
          <tr>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
            >
              {this.props.paymentDays[0]}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
            >
              {this.props.paymentDays[1]}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
            >
              {this.props.paymentDays[2]}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
            >
              {this.props.paymentDays[3]}
            </td>
            <td
              style={{ ...styles.td, ...styles.fontBold }}
              className="text-center"
            >
              {this.props.paymentDays[4]}
            </td>
          </tr>
          {this.props.amounts.map((amount, index) => (
            <>
              <tr
                id={`${this.props.id}-${index}`}
                key={`${this.props.id}-${index}`}
              >
                <td style={styles.td} className="text-center">
                  {index + 1}
                </td>
                <td style={styles.td}>
                  {amount.Socio.nombre} {amount.Socio.apellido_paterno}{' '}
                  {amount.Socio.apellido_materno}
                </td>
                <td style={styles.td}>
                  {formatString.setLegiblePrice(
                    this.setPay(this.props.requisition, amount.monto_autorizado)
                  )}
                </td>
                <td style={styles.td}></td>
                <td style={styles.td}></td>
                <td style={styles.td}></td>
                <td style={styles.td}></td>
                <td style={styles.td}></td>
              </tr>
            </>
          ))}
          <tr>
            <td style={styles.td}></td>
            <td style={{ ...styles.td, ...styles.fontBold }}>TOTAL</td>
            <td style={{ ...styles.td, ...styles.fontBold }}>
              {formatString.setLegiblePrice(this.state.totalPayWeek)}
            </td>
            <td style={styles.td}></td>
            <td style={styles.td}></td>
            <td style={styles.td}></td>
            <td style={styles.td}></td>
            <td style={styles.td}></td>
          </tr>
          <tr>
            <td style={styles.td}></td>
            <td
              style={styles.td}
            >{`${this.props.promoter.nombre} ${this.props.promoter.apellido_paterno} ${this.props.promoter.apellido_materno}`}</td>
            <td style={styles.td} colSpan="6"></td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default Table;

const styles = {
  table: {
    borderTop: '1px solid #dee2e6',
    borderLeft: '1px solid #dee2e6',
    // borderCollapse: 'collapse',
    width: '100%',
  },
  td: {
    borderRight: '1px solid #dee2e6',
    borderBottom: '1px solid #dee2e6',
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem',
    paddingTop: '1px',
    paddingBottom: '1px',
    fontSize: '7pt',
    lineHeight: '1.5',
  },
  fontBold: {
    fontWeight: 'bold',
  },
};
